import "./AccountSubscriptionBills.css";
import Crown from "../../../../../components/atoms/icons/tarifs/crown/Crown";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ArrowSm from "../../../../../components/atoms/icons/general/arrowSm/ArrowSm";
import FilledButton from "../../../../../components/molecules/buttons/filledButton/FilledButton";
import { useAuth } from "../../../../../context/AuthContext";
import CancelAutoRenewalModal from "../../../../../components/forms/modals/account/cancelAutoRenewalModal/CancelAutoRenewalModal";
import { fetchClientBillingLinkApi } from "../../../../../api/crm/CrmSubscriptionApi";
import AppContext from "../../../../../context/AppContext";
import { stringToDate } from "../../../../../utils/Utils";

function AccountSubscriptionBills() {
  const { subscription, refreshUserData, getUuid } = useAuth();
  const { setModalContent, setModalVisible, createNotification } = useContext(AppContext);
  const [billingLink, setBillingLink] = useState("");

  useEffect(() => {
    fetchBillingLink();
  }, []);

  async function fetchBillingLink() {
    try {
      const res = (
        await fetchClientBillingLinkApi(getUuid(), process.env.REACT_APP_URL + "/mon-compte/mes-abonnements-factures")
      ).data;
      setBillingLink(res);
    } catch (error) {
      createNotification(
        <>Une erreur est survenue lors de la création du lien vers vos factures. Veuillez réessayer.</>,
        "var(--red)",
        "var(--dark-blue)",
      );
    }
  }

  function getEstimationsCount(subscription) {
    if (!subscription) return "N/A";
    if (subscription.nb_estimations === -1 || subscription.nb_estimations === undefined) return "Illimité";
    return subscription.nb_estimations;
  }

  function showCancelAutoRenewalModal(e) {
    e.preventDefault();

    setModalContent({
      title: "Ne pas renouveler mon abonnement",
      content: <CancelAutoRenewalModal subscriptionUuid={subscription.sub_id} callback={refreshUserData} />,
    });

    setModalVisible(true);
  }

  function getSubcriptionState(subscription) {
    if (subscription.is_active && subscription.is_auto_renewed && !subscription.is_cancelled) return "Actif";
    if (subscription.is_active && !subscription.is_auto_renewed && subscription.is_cancelled)
      return "Résiliation en cours";
    if (!subscription.is_active && !subscription.is_auto_renewed && subscription.is_cancelled) return "Résilié";
    if (!subscription.is_active && !subscription.is_auto_renewed && !subscription.is_cancelled) return "Echec paiement";
    if (subscription.is_active && subscription.is_free_trial) return "Actif";

    if (subscription.is_active) return "Actif";
    return "Inactif";
  }

  function getToolsAccess(subscription) {
    if (!subscription || !subscription.is_active) return "Non";

    if (!subscription.is_free_trial) return "Oui";

    if (subscription.has_tools_access) return "Oui";

    return "Non";
  }

  function RenewalDateRow({ subscription }) {
    if (!subscription?.date_end_sub) return <></>;

    const renewalDate = subscription.date_end_sub.split(" ")[0];

    let engagementEndDate = "";
    if (
      subscription?.is_commitment &&
      subscription?.commitment_duration_in_months > 0 &&
      subscription?.date_start_sub
    ) {
      const startDate = new Date(stringToDate(subscription.date_start_sub));
      const endDate = new Date(startDate);
      endDate.setMonth(endDate.getMonth() + subscription.commitment_duration_in_months);

      const day = String(endDate.getDate()).padStart(2, "0");
      const month = String(endDate.getMonth() + 1).padStart(2, "0");
      const year = endDate.getFullYear();
      engagementEndDate = `${day}/${month}/${year}`;
    }

    return (
      <>
        <p>
          Date de {!subscription.is_cancelled ? "renouvellement" : "fin"}&nbsp;:{" "}
          <span className='outfit-bold'>{renewalDate}</span>
        </p>

        {subscription?.is_commitment === true &&
          subscription?.commitment_duration_in_months > 0 &&
          engagementEndDate && (
            <p>
              Date de fin d'engagement&nbsp;: <span className='outfit-bold'>{engagementEndDate}</span>
            </p>
          )}
      </>
    );
  }

  return (
    <>
      <section className='container'>
        <div className='row-1000'>
          <div className='col'>
            <div className={"offre-container " + subscription?.plan?.toLowerCase()}>
              {subscription?.price_name === "Maëstro" && <Crown width='90px' className='offre-crown' />}
              <p>
                Abonnement en cours&nbsp;:{" "}
                <span className='outfit-bold'>{subscription?.plan?.toUpperCase() ?? "Aucun"}</span>
              </p>
              {subscription && (
                <>
                  <p>
                    État&nbsp;: <span className='outfit-bold'>{getSubcriptionState(subscription)}</span>
                  </p>
                  <p>
                    Nombre d'estimations restantes&nbsp;:{" "}
                    <span className='outfit-bold'>{getEstimationsCount(subscription)}</span>
                  </p>
                  <p>
                    Accès aux outils&nbsp;: <span className='outfit-bold'>{getToolsAccess(subscription)}</span>
                  </p>
                  <p>
                    Date de souscription&nbsp;:{" "}
                    <span className='outfit-bold'>{subscription?.date_start_sub?.split(" ")[0]}</span>
                  </p>
                  <RenewalDateRow subscription={subscription} />
                </>
              )}
            </div>
          </div>
          <div className='col'>
            <div className='offre-buttons-container'>
              {subscription && !subscription?.is_free_trial && (
                <Link className='link-with-arrow bold' to={billingLink} target='_blank'>
                  Mes moyens de paiement et mes factures
                  <ArrowSm rotation='180deg' />
                </Link>
              )}
              {!subscription?.is_commitment && (
                <Link className='link-with-arrow' to='/tarifs'>
                  Choisir mon abonnement&nbsp;
                  <ArrowSm rotation='180deg' />
                </Link>
              )}
              {subscription?.is_active && !subscription.is_cancelled && !subscription?.is_free_trial && (
                <Link className='link-with-arrow' onClick={showCancelAutoRenewalModal}>
                  Ne pas renouveler mon abonnement&nbsp;
                  <ArrowSm rotation='180deg' />
                </Link>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default AccountSubscriptionBills;
